export var platformsConfig = {
    booksy: {
        id: 'booksy',
        name: 'Booksy',
        loginPageUrl: 'https://booksy.com/pro/start.html',
        authenticationItemName: 'Token',
    },
    thecut: {
        id: 'thecut',
        name: 'The Cut',
        loginPageUrl: '',
        authenticationItemName: 'Token',
    },
    square_aka_block: {
        id: 'square_aka_block',
        name: 'Square',
        loginPageUrl: 'https://squareup.com/login',
        authenticationItemName: 'Token',
    },
    tentoeight: {
        id: 'tentoeight',
        name: '10 to 8',
        loginPageUrl: 'https://10to8.com/login/',
        authenticationItemName: '',
    },
    acuity_by_squarespace: {
        id: 'acuity_by_squarespace',
        name: 'Acuity',
        loginPageUrl: 'https://secure.acuityscheduling.com/',
        authenticationItemName: '',
    },
    appinstitute: {
        id: 'appinstitute',
        name: 'AppInstitute',
        loginPageUrl: 'https://www.appinstitutebooking.com/login',
        authenticationItemName: '',
    },
    appointedd: {
        id: 'appointedd',
        name: 'Appointedd',
        loginPageUrl: 'https://app.appointedd.com/',
        authenticationItemName: '',
    },
    appointfix: {
        id: 'appointfix',
        name: 'Appointfix',
        loginPageUrl: 'Mobile Application',
        authenticationItemName: '',
    },
    daysmart_salon_aka_salon_iris: {
        id: 'daysmart_salon_aka_salon_iris',
        name: 'AppointmentPlus (Daysmart Appointments)',
        loginPageUrl: 'https://www.daysmartappointments.com/',
        authenticationItemName: '',
    },
    appointy: {
        id: 'appointy',
        name: 'Appointy',
        loginPageUrl: 'Appointy Login Link',
        authenticationItemName: '',
    },
    barberly: {
        id: 'barberly',
        name: 'Barberly',
        loginPageUrl: 'https://portal.barberly.com/login',
        authenticationItemName: '',
    },
    bookedby: {
        id: 'bookedby',
        name: 'BookedBy',
        loginPageUrl: 'https://zona.bookedby.com/auth/sign-in',
        authenticationItemName: '',
    },
    booker_by_mindbody: {
        id: 'booker_by_mindbody',
        name: 'Booker',
        loginPageUrl: 'https://www.booker.com/',
        authenticationItemName: '',
    },
    bookedin: {
        id: 'bookedin',
        name: 'Bookedin',
        loginPageUrl: 'https://scheduler.bookedin.com/',
        authenticationItemName: '',
    },
    bookedya: {
        id: 'bookedya',
        name: 'Bookedya',
        loginPageUrl: 'https://app.bookedya.com/',
        authenticationItemName: '',
    },
    bookeo: {
        id: 'bookeo',
        name: 'Bookeo',
        loginPageUrl: 'https://signin.bookeo.com/',
        authenticationItemName: '',
    },
    bookly: {
        id: 'bookly',
        name: 'Bookly/Word Press',
        loginPageUrl: 'http://www.neilsmithhair.co.uk/wp-admin/admin.php?page=bookly-calendar',
        authenticationItemName: '',
    },
    booksyversum: {
        id: 'booksyversum',
        name: 'Booksy formerly Versum',
        loginPageUrl: 'https://panel.versum.com/signin/en?_ga=2.208004370.1442382933.1665678877-1743261999.1665678877',
        authenticationItemName: '',
    },
    boulevard: {
        id: 'boulevard',
        name: 'Boulevard',
        loginPageUrl: 'https://dashboard.boulevard.io/login',
        authenticationItemName: '',
    },
    clover: {
        id: 'clover',
        name: 'Clover',
        loginPageUrl: 'https://clover.com/login',
        authenticationItemName: '',
    },
    cloversalonscheduler: {
        id: 'cloversalonscheduler',
        name: 'Clover Salon Scheduler',
        loginPageUrl: 'https://reports.appheaven.us/customer/index.php?merchantid=[merchantid]',
        authenticationItemName: '',
    },
    daysmartsalon: {
        id: 'daysmartsalon',
        name: 'Daysmart Salon / Salon Iris',
        loginPageUrl: 'https://online.daysmartsalon.com/beta/',
        authenticationItemName: '',
    },
    effexx: {
        id: 'effexx',
        name: 'Effexx',
        loginPageUrl: '',
        authenticationItemName: '',
    },
    envisioncloud: {
        id: 'envisioncloud',
        name: 'Envision Cloud',
        loginPageUrl: 'https://login.envisiongo.com',
        authenticationItemName: '',
    },
    facebookbusiness: {
        id: 'facebookbusiness',
        name: 'Facebook Business',
        loginPageUrl: 'https://business.facebook.com/',
        authenticationItemName: '',
    },
    fresha: {
        id: 'fresha',
        name: 'Fresha',
        loginPageUrl: 'https://partners.fresha.com/users/sign-in?redirectTo=%2F',
        authenticationItemName: '',
    },
    genbook: {
        id: 'genbook',
        name: 'Genbook',
        loginPageUrl: 'https://www.genbook.com/',
        authenticationItemName: '',
    },
    gettimely: {
        id: 'gettimely',
        name: 'Get Timely',
        loginPageUrl: 'https://www.gettimely.com/',
        authenticationItemName: '',
    },
    giftup: {
        id: 'giftup',
        name: 'Gift Up',
        loginPageUrl: 'https://www.giftup.com/',
        authenticationItemName: '',
    },
    glossgenius: {
        id: 'glossgenius',
        name: 'Gloss Genius',
        loginPageUrl: 'https://glossgenius.com/',
        authenticationItemName: '',
    },
    gopanache: {
        id: 'gopanache',
        name: 'Go Panache',
        loginPageUrl: 'https://www.gopanache.com/',
        authenticationItemName: '',
    },
    growthzilla: {
        id: 'growthzilla',
        name: 'Growthzilla',
        loginPageUrl: 'https://account.growthzilla.com/#/login',
        authenticationItemName: '',
    },
    hairmax: {
        id: 'hairmax',
        name: 'Hair Max',
        loginPageUrl: '',
        authenticationItemName: '',
    },
    klippedapp: {
        id: 'klippedapp',
        name: 'Klipped App',
        loginPageUrl: 'Mobile Application - "Klipped Business"',
        authenticationItemName: '',
    },
    livechair: {
        id: 'livechair',
        name: 'Live Chair',
        loginPageUrl: 'Mobile Application',
        authenticationItemName: '',
    },
    meevo: {
        id: 'meevo',
        name: 'Meevo',
        loginPageUrl: 'https://na0.meevo.com/home?tenantId=101878#/',
        authenticationItemName: '',
    },
    milano: {
        id: 'milano',
        name: 'Milano',
        loginPageUrl: '',
        authenticationItemName: '',
    },
    millennium: {
        id: 'millennium',
        name: 'Millennium',
        loginPageUrl: '',
        authenticationItemName: '',
    },
    mindbody: {
        id: 'mindbody',
        name: 'Mindbody',
        loginPageUrl: 'https://clients.mindbodyonline.com/launch',
        authenticationItemName: '',
    },
    mytime: {
        id: 'mytime',
        name: 'MyTime',
        loginPageUrl: 'mytime.com',
        authenticationItemName: '',
    },
    nearcut: {
        id: 'nearcut',
        name: 'Nearcut',
        loginPageUrl: 'https://Squireisthebest.nearcut.com/users/sign_in',
        authenticationItemName: '',
    },
    ovatu: {
        id: 'ovatu',
        name: 'Ovatu',
        loginPageUrl: 'https://ovatu.com/location/user/login',
        authenticationItemName: '',
    },
    phorest: {
        id: 'phorest',
        name: 'Phorest',
        loginPageUrl: 'https://www.phorest.com/us/downloads/',
        authenticationItemName: '',
    },
    rosy: {
        id: 'rosy',
        name: 'ROSY/Salon Runner',
        loginPageUrl: 'https://www.rosysalonsoftware.com/',
        authenticationItemName: '',
    },
    resurva: {
        id: 'resurva',
        name: 'Resurva',
        loginPageUrl: 'https://resurva.com/',
        authenticationItemName: '',
    },
    salonbuilder: {
        id: 'salonbuilder',
        name: 'Salon Builder',
        loginPageUrl: 'https://salonbuilder.com/memberlogin.aspx',
        authenticationItemName: '',
    },
    saloniq: {
        id: 'saloniq',
        name: 'Salon IQ',
        loginPageUrl: 'https://hub.saloniq.co.uk/login/login',
        authenticationItemName: '',
    },
    salonlofts: {
        id: 'salonlofts',
        name: 'Salon Lofts',
        loginPageUrl: 'https://salonlofts.com/my_home',
        authenticationItemName: '',
    },
    salonmonster: {
        id: 'salonmonster',
        name: 'Salon Monster',
        loginPageUrl: 'https://salonmonster.com/6/salon/#/login',
        authenticationItemName: '',
    },
    schedulicity: {
        id: 'schedulicity',
        name: 'Schedulicity',
        loginPageUrl: 'https://www.schedulicity.com/',
        authenticationItemName: '',
    },
    schedulista: {
        id: 'schedulista',
        name: 'Schedulista',
        loginPageUrl: 'https://www.schedulista.com/',
        authenticationItemName: '',
    },
    setmore: {
        id: 'setmore',
        name: 'Setmore',
        loginPageUrl: 'https://www.setmore.com/',
        authenticationItemName: '',
    },
    shore: {
        id: 'shore',
        name: 'Shore',
        loginPageUrl: 'https://secure.shore.com/merchant/sign_in',
        authenticationItemName: '',
    },
    simplybook: {
        id: 'simplybook',
        name: 'SimplyBook.me',
        loginPageUrl: 'https://simplybook.me/en/',
        authenticationItemName: '',
    },
    smartscheduling: {
        id: 'smartscheduling',
        name: 'SmartScheduling',
        loginPageUrl: 'https://www.smartscheduling.com/en/account/login',
        authenticationItemName: '',
    },
    snapappointments: {
        id: 'snapappointments',
        name: 'SnapAppointments',
        loginPageUrl: 'https://snapappointments.com/',
        authenticationItemName: '',
    },
    spotonappointments: {
        id: 'spotonappointments',
        name: 'SpotOn Appointments',
        loginPageUrl: 'https://appointments.spoton.com/',
        authenticationItemName: '',
    },
    styleseat: {
        id: 'styleseat',
        name: 'Styleseat',
        loginPageUrl: 'https://www.styleseat.com/m/start',
        authenticationItemName: '',
    },
    stxcloud: {
        id: 'stxcloud',
        name: 'STX Cloud',
        loginPageUrl: 'https://stxcloud.com',
        authenticationItemName: '',
    },
    supersalon: {
        id: 'supersalon',
        name: 'SuperSalon',
        loginPageUrl: 'https://signin.supersalon.com/',
        authenticationItemName: '',
    },
    talech: {
        id: 'talech',
        name: 'Talech',
        loginPageUrl: 'https://www.talech.com/',
        authenticationItemName: '',
    },
    thryv: {
        id: 'thryv',
        name: 'Thryv',
        loginPageUrl: 'https://www.thryv.com/',
        authenticationItemName: '',
    },
    timely: {
        id: 'timely',
        name: 'Timely',
        loginPageUrl: 'https://app.gettimely.com/',
        authenticationItemName: '',
    },
    treatwell: {
        id: 'treatwell',
        name: 'Treatwell',
        loginPageUrl: 'https://www.treatwell.co.uk/protected-action/?route=/',
        authenticationItemName: '',
    },
    vagaro: {
        id: 'vagaro',
        name: 'Vagaro',
        loginPageUrl: 'https://www.vagaro.com/',
        authenticationItemName: '',
    },
    waitwhile: {
        id: 'waitwhile',
        name: 'WaitWhile',
        loginPageUrl: 'https://v2.waitwhile.com/login',
        authenticationItemName: '',
    },
    wix: {
        id: 'wix',
        name: 'Wix',
        loginPageUrl: 'https://www.wix.com/',
        authenticationItemName: '',
    },
    zenoti: {
        id: 'zenoti',
        name: 'Zenoti',
        loginPageUrl: 'https://zenoti.com/',
        authenticationItemName: '',
    },
    zolmi: {
        id: 'zolmi',
        name: 'ZOLMI',
        loginPageUrl: 'https://zolmi.com/',
        authenticationItemName: '',
    },
};
